import { datadogLogs } from "@datadog/browser-logs";
import { useEffect, useRef } from "react";

export function DatadogLogs() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    datadogLogs.init({
      clientToken: "pub65c873147c61b3f5667ee1a70ce605b5",
      site: "datadoghq.com",
      service: "offer-optimist",
      forwardErrorsToLogs: true,
      forwardConsoleLogs: "all",
      sessionSampleRate: 100,
    });
  }, []);

  return null;
}
